import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { Styles } from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import { useSnackbar } from "notistack";
import axios from "axios";
import { defaultVariables } from "../../../../config";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom"; // Import useLocation
import Container from '@mui/material/Container';
import FrontFilters from "../components/filters/FrontFilters";
import VendorsWithFilters from "../shops/VendorsWithFilters";
import MainSearchField from "../components/filters/MainSearchField";
import {setStore} from "trim-redux";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import {useMediaQuery} from "@mui/material";
import {theme} from "../../../../config/design/theme";
import {addressQueryString} from "../../../../config/values";

function DiscoverPage({ classes, industry }) {
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({});
    const navigate = useNavigate();
    const location = useLocation(); // Get the current location
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const config = {
        headers: {
            Accept: 'application/json',
        }
    }

    const { enqueueSnackbar } = useSnackbar();

    const loadData = () => {
        setLoading(true);
        axios.get(`${defaultVariables.url}/front/get-filter-list/${industry}${addressQueryString()}`, config)
            .then(response => {
                setData(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }


    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        loadData();
        setStore(({
            global_menu:industry
        }))
    }, [industry]);

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t(industry)}>
            <div className={classes.discoverLayout}>
                <Container maxWidth="xl" >
                    <Grid container spacing={2} justify="center">
                        {
                            !!isMobile &&
                            <Grid item size={12}>
                                <BreadCrumbs
                                    front
                                    firstText={t(industry)}
                                    firstLink={`/${industry}`}
                                    secondText={t('discover')}
                                />
                            </Grid>
                        }
                        <Grid item size={{ xs: 12, md: 3, lg: 2 }} >
                            {
                                !loading ?
                                    <FrontFilters
                                        filter_data={data}
                                        industry={industry}
                                        onFilterChange={(res) => setFilters(res)}
                                    />
                                    :
                                    null
                            }

                        </Grid>
                        <Grid item size={{ xs: 12, md: 9, lg: 10 }} >
                            <Grid container spacing={2}>
                                {
                                    !isMobile &&
                                    <Grid item size={12}>
                                        <BreadCrumbs
                                            front
                                            firstText={t(industry)}
                                            firstLink={`/${industry}`}
                                            secondText={t('discover')}
                                        />
                                    </Grid>
                                }
                                <Grid item size={12} className="mb-30">
                                    <MainSearchField industry={industry} />
                                </Grid>
                                <Grid item size={12}>
                                    <VendorsWithFilters industry={industry} filters={filters} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </AppAnimate>
    );
}

export default withStyles(Styles)(DiscoverPage);